import { industryServe } from "@/service";
import { defineStore } from "pinia";
export const useIndustryStore = defineStore("industry", {
  state: () => ({
    industry: false,
    industryIconList: [],
  }),
  actions: {
    async setIndustry() {
      const res = await industryServe.getIndustry();
      if (res.success) {
        this.industry = res.data;
      }
    },
    setIndustryIconList(val) {
      this.industryIconList = val;
    },
  },
});
